import { useEffect, useState } from "react";
import { createForm } from "../../createForm.js";
import { useKeepFormUpdated } from "./utils/useKeepFormUpdated.js";
const emptyObject = {};
function useCreateForm(name, maybeFields, maybeConfig, resetMode = "preserve", verbose = false) {
  const [fields, setFields] = useState(
    typeof maybeFields === "function" ? maybeFields() : maybeFields ?? emptyObject
  );
  useEffect(() => {
    if (!maybeFields) return;
    if (typeof maybeFields === "function") return;
    setFields(maybeFields);
  }, [maybeFields]);
  const [config, setConfig] = useState(
    typeof maybeConfig === "function" ? maybeConfig() : maybeConfig ?? emptyObject
  );
  useEffect(() => {
    if (!maybeConfig) return;
    if (typeof maybeConfig === "function") return;
    setConfig(maybeConfig);
  }, [maybeConfig]);
  const [formState] = useState(() => createForm(name, fields, config));
  useKeepFormUpdated(formState.api, resetMode, name, fields, config, verbose);
  return formState;
}
export {
  useCreateForm
};
//# sourceMappingURL=useCreateForm.js.map
